import React from "react";
import { useTranslation } from "react-i18next";
import videoIcon from "../assets/posts/video.svg";

export default function VideoThumb({ posterUrl = "", size = "w-10 h-10" }) {
  const { t } = useTranslation();

  return (
    <div
      className={`${size} relative rounded overflow-hidden bg-black-20 flex items-center justify-center flex-shrink-0`}
    >
      {posterUrl ? (
        <>
          <img
            src={posterUrl}
            alt={t("video.thumb")}
            className="absolute inset-0 w-full h-full object-cover"
          />
          <span className="relative w-6 h-6 rounded-full bg-black-900 bg-opacity-60 flex items-center justify-center">
            <svg viewBox="0 0 24 24" className="w-3 h-3 ml-0.5 text-white" fill="currentColor" aria-hidden="true">
              <path d="M8 5v14l11-7z" />
            </svg>
          </span>
        </>
      ) : (
        <img src={videoIcon} alt={t("video.thumb")} className="w-1/2 h-1/2 max-w-[32px] max-h-[32px]" />
      )}
    </div>
  );
}